import React, { Fragment } from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { FieldLayoutTwoColumn } from 'cstar-react-primitives';
import { InputGroup, SelectGroup } from 'cstar-react-primitives/lib/formik/index';

import { useFormatMessage } from '../../../../intl/intlHooks';
import { cashbotName } from '../../../core';
import { dropDownData } from './creditCardUtils';
import { creditCardMessages as msgs } from './creditCardMessages';
import { CreditCardImagesDisplay } from './CreditCardImagesDisplay';

export const CREDIT_CARD_TYPE = 'creditCardType';
export const CREDIT_CARD_NUMBER = 'creditCard';
export const EXPIRATION_MONTH = 'expMonth';
export const EXPIRATION_YEAR = 'expYear';
export const SECURITY_CODE = 'securityCode';

export const ccDefaultValues = {
   [CREDIT_CARD_TYPE]: '',
   [CREDIT_CARD_NUMBER]: '',
   [EXPIRATION_MONTH]: '',
   [EXPIRATION_YEAR]: '',
   [SECURITY_CODE]:''
};

export const CCNumberFormikField = ({ label, fieldName }) => (
    <Field
        name={fieldName}
        label={label}
        component={InputGroup}
        atts={{ type: 'tel', maxLength: 25, autoComplete: 'cc-csc' }}
        cashbotName={cashbotName}
    />
);

CCNumberFormikField.defaultProps = {
    fieldName: CREDIT_CARD_NUMBER
};
CCNumberFormikField.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string
};

export const CCExpMonthFormikField = ({ label, fieldName }) => (
    <Field
        name={fieldName}
        label={label}
        component={SelectGroup}
        options={dropDownData.monthList}
        atts={{ autoComplete: 'cc-exp-month' }}
        cashbotName={cashbotName}
    />
);

CCExpMonthFormikField.defaultProps = {
    fieldName: EXPIRATION_MONTH
};
CCExpMonthFormikField.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string
};
export const CCExpYearFormikField = ({ label, fieldName }) => (
    <Field
        name={fieldName}
        label={label}
        component={SelectGroup}
        options={dropDownData.fourDigitYears}
        atts={{ autoComplete: 'cc-exp-year' }}
        cashbotName={cashbotName}
    />
);

CCExpYearFormikField.defaultProps = {
    fieldName: EXPIRATION_YEAR
};
CCExpYearFormikField.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string
};

export const CCSecurityCodeFormikField = ({ label, fieldName }) => (
    <Field
        name={fieldName}
        label={label}
        component={InputGroup}
        atts={{ type: 'tel', maxLength: 4, autoComplete: 'cc-csc' }}
        cashbotName={cashbotName}
    />
);

CCSecurityCodeFormikField.defaultProps = {
    fieldName: SECURITY_CODE
};
CCSecurityCodeFormikField.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string
};

export const CreditCardFields = ({ acceptedCreditCards, selectedCard }) => {
    const formatMessage = useFormatMessage();
    return (
        <Fragment>
            <CCNumberFormikField label={formatMessage(msgs.numberLabel)} />
            <CreditCardImagesDisplay cardTypes={acceptedCreditCards} selectedCard={selectedCard} />
            <FieldLayoutTwoColumn>
                <CCExpMonthFormikField label={formatMessage(msgs.expiryMonthLabel)} />
                <CCExpYearFormikField label={formatMessage(msgs.expiryYearLabel)} />
            </FieldLayoutTwoColumn>
            <FieldLayoutTwoColumn>
                <CCSecurityCodeFormikField label={formatMessage(msgs.securityCodeLabel)} />
            </FieldLayoutTwoColumn>
        </Fragment>
    );
};

CreditCardFields.defaultProps = {
    selectedCard: undefined,
    acceptedCreditCards: ['visa', 'mastercard', 'discovercard', 'americanexpress']
};

CreditCardFields.propTypes = {
    acceptedCreditCards: PropTypes.array,
    selectedCard: PropTypes.string
};
